import { render, staticRenderFns } from "./TrainingManagement.vue?vue&type=template&id=a5cf1054&scoped=true"
import script from "./TrainingManagement.vue?vue&type=script&lang=js"
export * from "./TrainingManagement.vue?vue&type=script&lang=js"
import style0 from "./TrainingManagement.vue?vue&type=style&index=0&id=a5cf1054&prod&lang=scss"
import style1 from "./TrainingManagement.vue?vue&type=style&index=1&id=a5cf1054&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5cf1054",
  null
  
)

export default component.exports